import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import defaultSignature from '../../assets/stan-signature.png';

export const DocumentImageModal = ({ formik, show, handleClose, isReturnShipmentTab }) => {
    const values = isReturnShipmentTab ? formik.values.returnData : formik.values;
    const letterheadField = isReturnShipmentTab ? 'returnData.letterheadImg' : 'letterheadImg';
    const signatureField = isReturnShipmentTab ? 'returnData.signatureImg' : 'signatureImg';

    const handleImgChange = (e, imgType) => {
        if (imgType === 'letterhead') {
            formik.setFieldValue(letterheadField, e.target.files[0]);
        } else {
            formik.setFieldValue(signatureField, e.target.files[0]);
        }
    }

    const resetLetterHeadInput = () => {
        formik.setFieldValue(letterheadField, null);
    }

    const resetSignatureInput = () => {
        formik.setFieldValue(signatureField, null);
    }

    return (
        <Modal show={show} onHide={handleClose} backdrop='static'>
            <Modal.Header closeButton>Upload images</Modal.Header>
            <Modal.Body>
                <fieldset>
                    <legend>Upload images</legend>
                    <div className='img-upload'>
                        <Form.Group className='form-group'>
                            <Form.Label>Company letterhead image</Form.Label>
                            {values.letterheadImg ?
                                <div className='selected-img-text'>
                                    <i>Selected image: {values.letterheadImg.name}</i>
                                    <Button onClick={resetLetterHeadInput} className='link-btn'>Clear image</Button>
                                </div> :
                                <Form.Control
                                    type='file'
                                    onChange={(e) => handleImgChange(e, 'letterhead')}
                                    accept='image/png, image/gif'
                                />}
                        </Form.Group>
                        <div className='img-preview-letterhead'>
                            {values.letterheadImg ?
                                <img src={URL.createObjectURL(values.letterheadImg)} alt='letterhead preview' /> :
                                <p>Select an image to preview</p>
                            }
                        </div>
                    </div>
                    <div className='img-upload'>
                        <Form.Group className='form-group'>
                            <Form.Label>Signature image</Form.Label>
                            {values.signatureImg ?
                                <div className='selected-img-text'>
                                    <i>Selected image: {values.signatureImg.name}</i>
                                    <Button onClick={resetSignatureInput} className='link-btn'>Clear image</Button>
                                </div>
                                :
                                <div className='img-file-upload'>
                                    <Form.Control
                                        type='file'
                                        onChange={(e) => handleImgChange(e, 'signature')}
                                        accept='image/png, image/gif'
                                        disabled={values.useDefaultSignatureImg}
                                    />
                                    <p>Or</p>
                                    <Form.Check
                                        name={isReturnShipmentTab ? 'returnData.useDefaultSignatureImg' : 'useDefaultSignatureImg'}
                                        type='checkbox'
                                        label='Use default'
                                        checked={values.useDefaultSignatureImg}
                                        {...formik.getFieldProps(isReturnShipmentTab ? 'returnData.useDefaultSignatureImg' : 'useDefaultSignatureImg')}
                                    />
                                </div>
                            }
                        </Form.Group>
                        <div className='img-preview-signature'>
                            {values.useDefaultSignatureImg ?
                                <img src={defaultSignature} alt='signature preview' /> :
                                values.signatureImg ?
                                    <img src={URL.createObjectURL(values.signatureImg)} alt='signature preview' /> :
                                    <p>Select an image to preview</p>
                            }
                        </div>
                    </div>
                    <p>Note: Acceptable file types for letterhead and signature images are .gif and .png</p>
                </fieldset>
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={handleClose} className='purple-btn'>Ok</Button>
            </Modal.Footer>
        </Modal>
    )
}